import PageableRs from '@domain/rs/common/PageableRs';
import PassReviewPostListGetRs, {
  PassReviewListDto,
  PassReviewType,
} from '@domain/rs/passReview/PassReviewPostListGetRs';
import DateFormat from '@utils/date/format';

export default class PassReviewPostListGetVO extends PageableRs {
  posts: PassReviewListVO[];

  constructor(dto: PassReviewPostListGetRs) {
    super(dto);
    this.posts = dto.posts.map((item) => new PassReviewListVO(item));
  }
}

export class PassReviewListVO {
  sn: number;
  title: string;
  displayId: string;
  type: PassReviewType;
  typeText: string;
  createdDateTime: string;
  views: number;
  commentCount: number;

  constructor(dto: PassReviewListDto) {
    this.sn = dto.sn;
    this.title = dto.title;
    this.displayId = dto.displayId;
    this.type = dto.type;
    this.typeText = this.getTypeText(dto.type);
    this.createdDateTime = DateFormat.format(new Date(dto.createdDateTime), 'yyyy.MM.dd');
    this.views = dto.views;
    this.commentCount = dto.commentCount;
  }

  private getTypeText = (type: PassReviewType) => {
    switch (type) {
      case 'BEST':
        return 'BEST';
      case 'NOTICE':
        return '공지';
      default:
        return '';
    }
  };
}
